import React from 'react';
import { Typography, Box } from '@mui/material';
import { FlowStepBadge, type FlowStep } from './FlowStepBadge';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  flowStep?: FlowStep;
}

export const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, actions, flowStep }) => {
  return (
    <Box sx={{ mb: 3, width: '100%' }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {flowStep && <FlowStepBadge step={flowStep} />}
          <Box>
            <Typography
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 700,
                fontSize: '1.4rem',
                color: '#0f2847',
                lineHeight: 1.3,
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                sx={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontWeight: 400,
                  fontSize: '0.82rem',
                  color: '#94a3b8',
                  mt: 0.3,
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {actions && (
          <Box sx={{ ml: 2 }}>
            {actions}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          width: 36,
          height: 3,
          background: 'linear-gradient(90deg, #3b82f6, #10b981)',
          borderRadius: 2,
          mt: 1.5,
        }}
      />
    </Box>
  );
};
